'use client';

import 'BomdisoftComponents/admin-frame/styles.css';
import { LinkButton } from 'BomdisoftComponents/buttons/link';
import { Section } from 'BomdisoftComponents/section/index';
import { getLanguageFromLocale, returnHome } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type NotFoundPageProps = {
  homeHref?: string;
};

export const NotFoundPage = ({ homeHref = '/' }: NotFoundPageProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);

  return (
    <Section className='bomdisoft-admin-not-found'>
      <LinkButton data-testid='not-found-home' href={homeHref} variant='contained'>
        {returnHome[language]}
      </LinkButton>
    </Section>
  );
};
